import { PRODUCT_PARAM_TO_PRODUCT_QUESTION_VALUES } from "constants/contact-sales-product-options";
export const HUBSPOT_FORM_CALLBACK_TYPE = "hsFormCallback";
export const HUBSPOT_FORM_ERROR_EVENT = "onFormError";
export const HUBSPOT_UNKNOWN_ERROR_TYPE = "UNKNOWN";
export const HUBSPOT_UNKNOWN_ERROR_MESSAGE = "Unknown error";
export const leadSourceDefaultValue = "Website - Contact Sales";
export const leadSourceConfigList = [
    {
        value: "Website - Contact Sales",
        text: "Website - Contact Sales"
    },
    {
        value: "Landing Page - Contact Sales",
        text: "Landing Page - Contact Sales"
    },
    {
        value: "Website - Request a Demo",
        text: "Website - Request a Demo"
    },
    {
        value: "Linkedin - Contact Sales",
        text: "Linkedin - Contact Sales"
    },
    {
        value: "Linkedin - Request a Demo",
        text: "Linkedin - Request a Demo"
    },
    {
        value: "Content",
        text: "Content"
    },
    {
        value: "Contact Sales - Tech Partner",
        text: "Contact Sales - Tech Partner"
    },
    {
        value: "Webinar",
        text: "Webinar"
    },
    {
        value: "Mobile - Contact Sales",
        text: "Mobile - Contact Sales"
    },
    {
        value: "Xing",
        text: "Xing"
    },
    {
        value: "Website - Nurture Contact Sales",
        text: "Website - Nurture Contact Sales"
    },
    {
        value: "Event",
        text: "Event"
    }
];
export const CUSTOM_EVENTS = {
    FORM_SUBMISSION: "pe5945317_website_contact_sales_form_submission",
    ELIGIBLE_FOR_WEBSITE_BOT: "pe5945317_eligible_for_website_bot",
    BAM_CALENDAR_REACHED: "pe5945317_website_bam_calendar"
};
export const HUBSPOT_API_FIRSTNAME = "firstname";
export const HUBSPOT_API_LASTNAME = "lastname";
export const HUBSPOT_API_EMAIL = "email";
export const HUBSPOT_API_JOB = "jobtitle";
export const HUBSPOT_API_PHONE = "phone";
export const HUBSPOT_API_COMPANY = "company";
export const HUBSPOT_API_COMPANY_SIZE = "company_size__c";
export const HUBSPOT_API_PRODUCT_QUESTION = "product_question_hs_forms";
export const HUBSPOT_API_HOW_CAN_HELP = "how_can_our_consulting_team_help_you";
export const HUBSPOT_API_USE_CASE_FORM_SELECTION = "use_case_form_selection";
export const HUBSPOT_API_CLUSTER = "cluster_hs";
export const HUBSPOT_API_VISITOR = "visitor_id";
export const HUBSPOT_API_SOURCE = "leadsource";
export const HUBSPOT_API_FROM = "from";
export const HUBSPOT_API_PRIVACY_CONSENT = "seen_legal_disclaimer";
export const HUBSPOT_API_PRICING_VERSION = "website_pricing_version";
export const HUBSPOT_API_RECENT_CONVERSION_URL = "recent_conversion_url";
export const HUBSPOT_API_RECENT_CONVERSION_REFERRER_PAGE = "recent_conversion_referrer_page";
export const HUBSPOT_API_AB_TEST_NAME = "web_presence_test_name";
export const HUBSPOT_API_HOMEPAGE_EXACT_AB_TEST_NAME = "homepage_test_variant";
export const HUBSPOT_API_UTM_SOURCE = "utm_source";
export const HUBSPOT_API_UTM_CAMPAIGN = "utm_campaign";
export const HUBSPOT_API_UTM_TERM = "utm_term";
export const HUBSPOT_API_UTM_BANNER = "utm_banner";
export const HUBSPOT_API_UTM_CONTENT = "utm_content";
export const HUBSPOT_API_UTM_MEDIUM = "utm_medium";
export const HUBSPOT_CONTACT_SALES_CTA = "contact_sales_cta";
export const HUBSPOT_CONTACT_SALES_CTA_TRANSLATED = "contact_sales_cta_translated";
export const HUBSPOT_API_ELIGIBLE_FOR_BOOK_A_MEETING = "eligible_for_book_a_meeting";
export const HUBSPOT_API_DEVICE = "device";
export const HUBSPOT_API_SYNCED_COUNTRY = "synced_country";
export const HUBSPOT_API_SYNCED_COUNTRY_CODE = "synced_country_code";
const HUBSPOT_API_UTM_ADGROUP = "utm_adgroup";
const HUBSPOT_API_UTM_KEYWORD = "utm_keyword";
const HUBSPOT_API_NUMBER_OF_SEATS = "number_of_seats_last_selected_pricing_page";
export const URL_PARAM_FROM = "from";
export const PII_PARAMS = [
    HUBSPOT_API_FIRSTNAME,
    HUBSPOT_API_LASTNAME,
    HUBSPOT_API_EMAIL,
    HUBSPOT_API_PHONE
];
/* this is {label: String, value: String} objects list to fit the react-select input,
changing the values will break the form (in hubspot) */ export const productQuestionOptionsList = [
    {
        label: "contactSales.hubspotForm.form.productQuestion.workManagement",
        value: "Work & project management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.crm",
        value: "Sales & CRM"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.emailCampaigns",
        value: "Email marketing"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.product",
        value: "Product management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.softwareDevelopment",
        value: "Software development"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.service",
        value: "Ticketing & service management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.other",
        value: "Other"
    }
];
export const whatToAchieveOptionsList = [
    {
        label: "contactSales.hubspotForm.form.whatToAchieve.manageWork",
        value: "Manage my team's work in one place"
    },
    {
        label: "contactSales.hubspotForm.form.whatToAchieve.automations",
        value: "Reduce busywork with automations and workflows"
    },
    {
        label: "contactSales.hubspotForm.form.whatToAchieve.aiAgents",
        value: "Drive business results with AI agents doing the work"
    },
    {
        label: "contactSales.hubspotForm.form.whatToAchieve.missionCritical",
        value: "Transform mission-critical work with AI"
    },
    {
        label: "contactSales.hubspotForm.form.whatToAchieve.exploring",
        value: "Not sure yet, just exploring"
    }
];
export { PRODUCT_PARAM_TO_PRODUCT_QUESTION_VALUES };
export const getProductQuestionOptionsByParam = (productParam)=>{
    const values = PRODUCT_PARAM_TO_PRODUCT_QUESTION_VALUES[productParam === null || productParam === void 0 ? void 0 : productParam.toLowerCase()];
    if (!values) return null;
    return productQuestionOptionsList.filter((option)=>values.includes(option.value));
};
// The UTM consts are used as both url param names and keys in the local storage
const UTM_SOURCE = "utm_source";
const UTM_CAMPAIGN = "utm_campaign";
const UTM_BANNER = "utm_banner";
const UTM_CONTENT = "utm_content";
const UTM_ADGROUP = "utm_adgroup";
const UTM_MEDIUM = "utm_medium";
const UTM_KEYWORD = "utm_keyword";
export const NUMBER_OF_SEATS_PARAM = "number_of_seats_last_selected_pricing_page";
export const NUMBER_OF_CONTACTS_PARAM = "number_of_contacts_last_selected_pricing_page";
export const SALES_ENRICHMENT_PARAM_TYPES = {
    URL_PARAM: "url_param"
};
export const SALES_ENRICHMENT_PARAM_LIST = [
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_SOURCE,
        paramName: UTM_SOURCE
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_CAMPAIGN,
        paramName: UTM_CAMPAIGN
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_BANNER,
        paramName: UTM_BANNER
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_CONTENT,
        paramName: UTM_CONTENT
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_ADGROUP,
        paramName: UTM_ADGROUP
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_MEDIUM,
        paramName: UTM_MEDIUM
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_KEYWORD,
        paramName: UTM_KEYWORD
    },
    {
        hubspotApiName: HUBSPOT_API_NUMBER_OF_SEATS,
        paramName: NUMBER_OF_SEATS_PARAM
    }
];
export const RECENT_CONVERSION_URL_QUERY_PARAM = "recent_conversion_url";
// HubSpot Forms Embed API Configuration
export const HUBSPOT_FORMS_EMBED_CONFIG = {
    // Base URL for HubSpot form embedding API
    BASE_URL: "https://forms.hsforms.com/embed/v3/form",
    // Static app identifier for form embedding requests
    STATIC_APP: "forms-embed",
    // Version of the HubSpot forms embed library
    STATIC_APP_VERSION: "1.9395",
    // Combined app info header value for request identification
    STATIC_APP_INFO: "forms-embed-1.9395",
    // Key for the HubSpot cookie in the URL params
    HUTK_PARAM_KEY: "hutk"
};
